<script lang="ts">
	import type { CustomBlockComponentProps } from '@portabletext/svelte';
	import type { Snippet } from 'svelte';

	interface Props {
		portableText: CustomBlockComponentProps<{ url: string; href: string; external: boolean }>;
		children: Snippet;
	}

	let { portableText, children }: Props = $props();

	let href = $derived(portableText.value.url || portableText.value.href);
</script>

{#if portableText.value.external}
	<a {href} target="_blank" rel="noopener noreferrer" class="underline">{@render children()}</a>
{:else}
	<a {href} class="underline">{@render children()}</a>
{/if}
